/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
export const FETCH_USER_DASHBOARDS = 'FETCH_USER_DASHBOARDS'
export const FETCH_USER_DASHBOARDS_SUCCESS = 'FETCH_USER_DASHBOARDS_SUCCESS'
export const FETCH_USER_DASHBOARDS_FAILURE = 'FETCH_USER_DASHBOARDS_FAILURE'


export const CREATE_USER_DASHBOARDS = 'CREATE_USER_DASHBOARDS'
export const CREATE_USER_DASHBOARDS_SUCCESS = 'CREATE_USER_DASHBOARDS_SUCCESS'
export const CREATE_USER_DASHBOARDS_FAILURE = 'CREATE_USER_DASHBOARDS_FAILURE'


export const UPDATE_USER_DASHBOARDS = 'UPDATE_USER_DASHBOARDS'
export const UPDATE_USER_DASHBOARDS_SUCCESS = 'UPDATE_USER_DASHBOARDS_SUCCESS'
export const UPDATE_USER_DASHBOARDS_FAILURE = 'UPDATE_USER_DASHBOARDS_FAILURE'


export const DELETE_USER_DASHBOARDS = 'DELETE_USER_DASHBOARDS'
export const DELETE_USER_DASHBOARDS_SUCCESS = 'DELETE_USER_DASHBOARDS_SUCCESS'
export const DELETE_USER_DASHBOARDS_FAILURE = 'DELETE_USER_DASHBOARDS_FAILURE'

export const FETCH_USER_DASHBOARD = 'FETCH_USER_DASHBOARD'
export const FETCH_USER_DASHBOARD_SUCCESS = 'FETCH_USER_DASHBOARD_SUCCESS'
export const FETCH_USER_DASHBOARD_FAILURE = 'FETCH_USER_DASHBOARD_FAILURE'

export const RESET_USER_DASHBOARD_STORE ='RESET_USER_DASHBOARD_STORE'

